"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _getYouTubeUrl = _interopRequireDefault(require("./helpers/getYouTubeUrl"));

var _getVimeoUrl = _interopRequireDefault(require("./helpers/getVimeoUrl"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var EmbeddedVideo = function EmbeddedVideoComponent(_ref) {
  var providerName = _ref.providerName,
      url = _ref.url,
      title = _ref.title;
  var videoUrl;

  if (providerName === 'YouTube') {
    videoUrl = (0, _getYouTubeUrl["default"])(url);
  } else if (providerName === 'Vimeo') {
    videoUrl = (0, _getVimeoUrl["default"])(url);
  }

  return videoUrl && /*#__PURE__*/_react["default"].createElement("iframe", {
    height: "100%",
    width: "100%",
    title: title,
    src: videoUrl,
    allowFullScreen: true,
    frameBorder: "0",
    allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
  });
};

EmbeddedVideo.propTypes = {
  providerName: _propTypes["default"].string.isRequired,
  url: _propTypes["default"].string.isRequired
};
var _default = EmbeddedVideo;
exports["default"] = _default;